export default __webpack_public_path__ + "static/media/const1.9b2dd350.jpg";